// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28fqs","textarea":"styles_textarea__3_MQ-"};